import React, { useEffect } from "react";
import "./ArchedBannerImage.css";

const ArchedBannerImageBottom = ({ 
  imageSrc, 
  bannerText = "Welcome!", 
  bannerColor = "rgba(0,0,0,0.6)", 
  textColor = "white" 
}) => {
  useEffect(()=>{
    window.open("https://rgyc.org", "_blank")
  }, [])
  return (
    <a href="https://rgyc.org" target="_blank" rel="noopener noreferrer">
    <div className="arched-banner-container">
        <img src={imageSrc} alt="Banner background" className="banner-image" />
        
        {/* Banner Background */}
        <div 
            className="banner-bg" 
            style={{ backgroundColor: bannerColor }}
        />

        {/* Curved SVG Text */}
        <svg className="arched-banner" viewBox="0 0 500 150">
            <path
            id="banner-curve-bottom"
            // d="M 50 50 Q 250 140 450 50"
            d="M 50 100 Q 250 0 450 100"
            fill="transparent"
            />
            <text fill={textColor}>
            <textPath href="#banner-curve-bottom" startOffset="50%" textAnchor="middle">
                {bannerText}
            </textPath>
            </text>
        </svg>
    </div>
    </a>
  );
};

export default ArchedBannerImageBottom;
